namespace $ {

	export const $shm_hitalama_map_widget_def_all = {
		text: {
			type: 'text',
			title: 'Текст',
			icon: $mol_icon_format_text,
		},
		image: {
			type: 'image',
			title: 'Изображение',
			icon: $mol_icon_image,
		},
		drawing: {
			type: 'drawing',
			title: 'Рисунок',
			icon: $mol_icon_pencil,
		},
		rect: {
			type: 'rect',
			title: 'Прямоугольник',
			icon: $mol_icon_rectangle_outline,
		},
		circle: {
			type: 'circle',
			title: 'Круг',
			icon: $mol_icon_circle_outline,
		},
		text_md: {
			type: 'text_md',
			title: 'Markdown',
			icon: $mol_icon_format_paragraph,
			background_default: 'var(--mol_theme_card)',
			settings_type: 'settings_text_md',
		},
		iframe: {
			type: 'iframe',
			title: 'Iframe',
			icon: $mol_icon_application_brackets,
			background_default: 'var(--mol_theme_card)',
		},
		code: {
			type: 'code',
			icon: $mol_icon_code_braces,
			background_default: 'var(--mol_theme_card)',
			code_view_type: 'customdom',
		},
		code_js: {
			type: 'code_js',
			title: 'JS',
			icon: $mol_icon_language_javascript,
			background_default: 'var(--mol_theme_card)',
			code_view_type: 'autoview',
		},
		method: {
			type: 'method',
			title: 'Method',
			icon: $mol_icon_code_braces,
			background_default: 'var(--mol_theme_card)',
		},
		code_ts: {
			type: 'code_ts',
			title: 'TS',
			icon: $mol_icon_language_typescript,
			background_default: 'var(--mol_theme_card)',
			code_view_type: 'customdom',
		},
		code_css: {
			type: 'code_css',
			title: 'CSS',
			icon: $mol_icon_language_css3,
			background_default: 'var(--mol_theme_card)',
		},
		code_html: {
			type: 'code_html',
			title: 'HTML',
			icon: $mol_icon_language_html5,
			background_default: 'var(--mol_theme_card)',
			code_view_type: 'iframe',
		},
		code_sql: {
			type: 'code_sql',
			title: 'SQL',
			icon: $mol_icon_database,
			background_default: 'var(--mol_theme_card)',
			code_view_type: 'autoview',
		},
		component: {
			type: 'component',
			title: 'Компонент',
			icon: $mol_icon_puzzle,
		},
		component_parser: {
			type: 'component_parser',
			title: 'Парсер компонентов',
			icon: $mol_icon_puzzle_edit,
			background_default: 'var(--mol_theme_card)',
		},
		component_view: {
			type: 'component_view',
			icon: $mol_icon_puzzle,
			background_default: 'var(--mol_theme_card)',
		},
		chart: {
			type: 'chart',
			icon: $mol_icon_chart_bar,
			background_default: 'var(--mol_theme_card)',
			settings_type: 'settings_chart',
		},
		echarts: {
			type: 'echarts',
			title: 'ECharts',
			icon: $mol_icon_chart_bar,
			background_default: 'var(--mol_theme_card)',
			settings_type: 'settings_echarts',
		},
		chart_filter: {
			type: 'chart_filter',
			icon: $mol_icon_filter,
			background_default: 'var(--mol_theme_card)',
		},
		customdom: {
			type: 'customdom',
			icon: $mol_icon_application_braces,
		},
		file: {
			type: 'file',
			icon: $mol_icon_file,
			background_default: 'var(--mol_theme_card)',
		},
		form: {
			type: 'form',
			title: 'Сбор 1% выгрузки БА',
			icon: $mol_icon_form_select,
			background_default: 'var(--mol_theme_card)',
		},
		form_edit: {
			type: 'form_edit',
			icon: $mol_icon_form_select,
			background_default: 'var(--mol_theme_card)',
		},
		form_custom: {
			type: 'form_custom',
			title: 'Редактор формы',
			icon: $mol_icon_form_select,
			background_default: 'var(--mol_theme_card)',
		},
		table: {
			type: 'table',
			title: 'Table',
			icon: $mol_icon_table,
			background_default: 'var(--mol_theme_card)',
			settings_type: 'settings_table',
		},
		tabulator: {
			type: 'tabulator',
			title: 'Tabulator',
			icon: $mol_icon_table,
			background_default: 'var(--mol_theme_card)',
			settings_type: 'settings_tabulator',
		},
		table_novirt: {
			type: 'table_novirt',
			icon: $mol_icon_table,
			background_default: 'var(--mol_theme_card)',
			settings_type: 'settings_table',
		},
		customizer: {
			type: 'customizer',
			title: 'Редактор виджетов',
			icon: $mol_icon_pencil,
			background_default: 'var(--mol_theme_card)',
		},
		custom: {
			type: 'custom',
			icon: $mol_icon_puzzle,
		},
		layout_vert: {
			type: 'layout_vert',
			title: 'Контейнер',
			icon: $mol_icon_view_column,
		},
		layout_hor: {
			type: 'layout_hor',
			title: 'Контейнер горизонтальный',
			icon: $mol_icon_view_column,
		},
		notebook: {
			type: 'notebook',
			title: 'Группа (notebook)',
			icon: $mol_icon_notebook,
		},
		notebook2: {
			type: 'notebook2',
			title: 'Notebook 2',
			icon: $mol_icon_notebook,
		},
		notebook_edit: {
			type: 'notebook_edit',
			icon: $mol_icon_notebook_edit,
		},
		notebook_preview: {
			type: 'notebook_preview',
			icon: $mol_icon_notebook,
		},
		chrome_telegram: {
			type: 'chrome_telegram',
			icon: $mol_icon_send,
		},
		viewport_frame: {
			type: 'viewport_frame',
			title: 'Viewport frame',
			icon: $mol_icon_image,
		},
		tokens: {
			type: 'tokens',
			title: 'Токены',
			icon: $mol_icon_key,
		},
		posts: {
			type: 'posts',
			title: 'Лента постов',
			icon: $mol_icon_format_list_bulleted,
			settings_type: 'settings_posts',
		},
		prompt: {
			type: 'prompt',
			title: 'Промпт',
			icon: $mol_icon_chat_question,
		},
		ai_request: {
			type: 'ai_request',
			title: 'AI запрос',
			icon: $mol_icon_robot,
			background_default: 'var(--mol_theme_card)',
		},
		opencode_session: {
			type: 'opencode_session',
			title: 'Агент-сессия',
			icon: $mol_icon_chat,
			background_default: 'var(--mol_theme_card)',
		},
		group: {
			type: 'group',
			icon: $mol_icon_group,
		},
		settings: {
			type: 'settings',
			title: 'Настройки',
			icon: $mol_icon_cog_outline,
			background_default: 'var(--mol_theme_card)',
		},
		settings_chart: {
			type: 'settings_chart',
			icon: $mol_icon_cog_outline,
			background_default: 'var(--mol_theme_card)',
		},
		settings_echarts: {
			type: 'settings_echarts',
			icon: $mol_icon_cog_outline,
			background_default: 'var(--mol_theme_card)',
		},
		settings_tabulator: {
			type: 'settings_tabulator',
			icon: $mol_icon_cog_outline,
			background_default: 'var(--mol_theme_card)',
		},
		settings_table: {
			type: 'settings_table',
			icon: $mol_icon_cog_outline,
			background_default: 'var(--mol_theme_card)',
		},
		settings_posts: {
			type: 'settings_posts',
			icon: $mol_icon_cog_outline,
			background_default: 'var(--mol_theme_card)',
		},
		settings_text_md: {
			type: 'settings_text_md',
			icon: $mol_icon_cog_outline,
			background_default: 'var(--mol_theme_card)',
		},
		settings_widget_page: {
			type: 'settings_widget_page',
			icon: $mol_icon_cog_outline,
			background_default: 'var(--mol_theme_card)',
		},
		autoview: {
			type: 'autoview',
			icon: $mol_icon_cube_scan,
		},
	} as const

	export type $shm_hitalama_map_widget_def_type_name = keyof typeof $shm_hitalama_map_widget_def_all & string
	
	export const $shm_hitalama_map_widget_def_default_type: $shm_hitalama_map_widget_def_type_name = 'text'

	export type $shm_hitalama_map_widget_def = {
		readonly type: string
		readonly title?: string
		readonly icon?: typeof $mol_icon
		readonly background_default?: string
		readonly settings_type?: $shm_hitalama_map_widget_def_type_name
		readonly code_view_type?: $shm_hitalama_map_widget_def_type_name
	}

	export const $shm_hitalama_map_widget_def_types = Object.keys(
		$shm_hitalama_map_widget_def_all
	) as $shm_hitalama_map_widget_def_type_name[]

	export function $shm_hitalama_map_widget_def( type: string ): $shm_hitalama_map_widget_def | undefined {
		return $shm_hitalama_map_widget_def_all[ type as $shm_hitalama_map_widget_def_type_name ]
	}

	export function $shm_hitalama_map_widget_def_exists( type: string ): type is $shm_hitalama_map_widget_def_type_name {
		return type in $shm_hitalama_map_widget_def_all
	}

	export function $shm_hitalama_map_widget_def_type_normalize( type: string | null | undefined ): $shm_hitalama_map_widget_def_type_name {
		if( type && $shm_hitalama_map_widget_def_exists( type ) ) return type
		return $shm_hitalama_map_widget_def_default_type
	}

	export const $shm_hitalama_map_widget_def_titles: Record<string, string | undefined> = Object.fromEntries(
		Object.values( $shm_hitalama_map_widget_def_all as Record<string, $shm_hitalama_map_widget_def> )
			.filter( def => def.title !== undefined )
			.map( def => [ def.type, def.title ] )
	)

	export const $shm_hitalama_map_widget_def_background_card_types = new Set<string>(
		Object.values( $shm_hitalama_map_widget_def_all as Record<string, $shm_hitalama_map_widget_def> )
			.filter( def => def.background_default == 'var(--mol_theme_card)' )
			.map( def => def.type )
	)

	export function $shm_hitalama_map_widget_def_settings_type( type: string ): $shm_hitalama_map_widget_def_type_name | null {
		return $shm_hitalama_map_widget_def( type )?.settings_type ?? null
	}

	export function $shm_hitalama_map_widget_def_has_settings( type: string ) {
		return $shm_hitalama_map_widget_def_settings_type( type ) !== null
	}

	export function $shm_hitalama_map_widget_def_code_view_type( type: string ) {
		return $shm_hitalama_map_widget_def( type )?.code_view_type ?? null
	}

	export function $shm_hitalama_map_widget_def_background_default( type: string ) {
		return $shm_hitalama_map_widget_def( type )?.background_default ?? 'transparent'
	}

}
